export default __webpack_public_path__ + "static/media/EmployeeDirectory.6b830653.png";